import { render, staticRenderFns } from "./HeaderListSpaceButton.vue?vue&type=template&id=2390a64b&scoped=true&"
import script from "./HeaderListSpaceButton.vue?vue&type=script&lang=js&"
export * from "./HeaderListSpaceButton.vue?vue&type=script&lang=js&"
import style0 from "./HeaderListSpaceButton.vue?vue&type=style&index=0&id=2390a64b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390a64b",
  null
  
)

export default component.exports